import React, { Component } from 'react';
import Nav from 'components/common/Nav';
export default class NotFound extends Component {
  render() {
    return (
      <div>
        <Nav />
        <div className="container-fluid fe-main-wrapper">
          <div className="fe-main-content">Not Found</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/common/NotFound/index.js